import { BaseIP } from "./CommonApi"

export const getGunMilanDataList= BaseIP+ "muhurt/transaction/getGunMilanData" //Get Party Master list (GET)
export const getGunMilanDataById= BaseIP+ "muhurt/transaction/getGunMilanDetailData" //Get Gun Milan List By ID (GET) (params=> ?id=1)
export const uploadGunMilanFile= BaseIP+ "muhurt/transaction/uploadGunMilanFile" //Upload Gun Milan File Data (POST)